module.exports = __webpack_public_path__ + "img/midbg.7144502b.png";